export function yLevenshtein(s1: string, s2: string) {
    const l1 = s1.length;
    const l2 = s2.length;

    // For all i and j, d[i][j] holds the Levenshtein distance between the first i characters of s and the first j characters of t.
    // Note that the array has (m+1)x(n+1) values.
    const d = new Array(l1 + 1);
    for(let i = 0; i <= l1; i++) {
        d[i] = new Array(l2 + 1);
        d[i][0] = i;
    }

    for(let j = 0; j <= l2; j++) {
        d[0][j] = j;
    }

    // Determine substring distances
    for(let j = 1; j <= l2; j++) {
        for(let i = 1; i <= l1; i++) {
            const cost = (s1.charAt(i - 1) == s2.charAt(j - 1)) ? 0 : 1;
            d[i][j] = Math.min(d[i][j - 1] + 1, // insertion
                d[i - 1][j] + 1, // deletion
                d[i - 1][j - 1] + cost); // substitution
        }
    }

    // Return the strings' distance
    return d[l1][l2];
}

export function yClosestMatch(query: string, options: string[], max_dist: number, distance_function: (s1: string, s2: string) => number = yLevenshtein) {
    let min_dist = max_dist + 1;
    let min_option: string | undefined;

    for(const option of options) {
        const dist = distance_function(query, option);
        if(dist < min_dist) {
            min_dist = dist;
            min_option = option;
        }
    }

    return min_option;
}
